import { __awaiter, __generator } from "tslib";
import { getOperationAST } from 'graphql';
import isPromise from 'is-promise';
import DataLoader from 'dataloader';
import { mergeExecutionParams } from './mergeExecutionParams';
import { splitResult } from './splitResult';
export function createBatchingExecutor(executor, dataLoaderOptions, extensionsReducer) {
    var loader = new DataLoader(createLoadFn(executor, extensionsReducer !== null && extensionsReducer !== void 0 ? extensionsReducer : defaultExtensionsReducer), dataLoaderOptions);
    return function (executionParams) { return loader.load(executionParams); };
}
function createLoadFn(executor, extensionsReducer) {
    var _this = this;
    return function (execs) { return __awaiter(_this, void 0, void 0, function () {
        var execBatches, index, exec, currentBatch, operationType, currentOperationType, containsPromises, executionResults, results;
        return __generator(this, function (_a) {
            execBatches = [];
            index = 0;
            exec = execs[index];
            currentBatch = [exec];
            execBatches.push(currentBatch);
            operationType = getOperationAST(exec.document, undefined).operation;
            while (++index < execs.length) {
                currentOperationType = getOperationAST(execs[index].document, undefined).operation;
                if (operationType === currentOperationType) {
                    currentBatch.push(execs[index]);
                }
                else {
                    currentBatch = [execs[index]];
                    execBatches.push(currentBatch);
                }
            }
            containsPromises = false;
            executionResults = [];
            execBatches.forEach(function (execBatch) {
                var mergedExecutionParams = mergeExecutionParams(execBatch, extensionsReducer);
                var executionResult = executor(mergedExecutionParams);
                if (isPromise(executionResult)) {
                    containsPromises = true;
                }
                executionResults.push(executionResult);
            });
            if (containsPromises) {
                return [2 /*return*/, Promise.all(executionResults).then(function (resultBatches) {
                        var results = [];
                        resultBatches.forEach(function (resultBatch, index) {
                            results = results.concat(splitResult(resultBatch, execBatches[index].length));
                        });
                        return results;
                    })];
            }
            results = [];
            executionResults.forEach(function (resultBatch, index) {
                results = results.concat(splitResult(resultBatch, execBatches[index].length));
            });
            return [2 /*return*/, results];
        });
    }); };
}
function defaultExtensionsReducer(mergedExtensions, executionParams) {
    var newExtensions = executionParams.extensions;
    if (newExtensions != null) {
        Object.assign(mergedExtensions, newExtensions);
    }
    return mergedExtensions;
}
//# sourceMappingURL=createBatchingExecutor.js.map